export default __webpack_public_path__ + "static/media/pinkCard.70e11858.png";